import {
	SUBUSER_RESOURCE,
	USERPROFILE_RESOURCE
} from '../api/resources';
import { addResource, deleteResource, fetchResource, updateResource } from './remote';

export const fetchUsers = fetchResource(SUBUSER_RESOURCE);
export const addUser = addResource(SUBUSER_RESOURCE, undefined, { success: 'User has been succesfully created', error: 'Email or Userame already exist' });
export const updateUser = updateResource(SUBUSER_RESOURCE);
export const deleteUser = deleteResource(SUBUSER_RESOURCE);
export const addPerm = addResource(
	SUBUSER_RESOURCE, 'add_perm'
	// {success: 'Permissions updated', error: 'An error occured while updating permissions'}
);

export const deletePerm = addResource(
	SUBUSER_RESOURCE, 'remove_perm'
	// {success: 'Permissions updated', error: 'An error occured while updating permissions'}
);

export const addPassword = addResource(
	SUBUSER_RESOURCE, 'password',
	{ success: 'Password has been changed.', error: 'An error occured while updating password' }
)

export const addEmail = addResource(
	SUBUSER_RESOURCE, 'email',
	{ success: 'email has been changed.', error: 'An error occured while updating email' }
)

export const addUserName = addResource(
	SUBUSER_RESOURCE, 'username',
	{ success: 'username has been changed.', error: 'An error occured while updating username' }
)

export const addFirstName = addResource(
	SUBUSER_RESOURCE, 'first_name',
	{ success: 'first name has been changed.', error: 'An error occured while updating first name' }
)

export const addLastName = addResource(
	SUBUSER_RESOURCE, 'last_name',
	{ success: 'last name has been changed.', error: 'An error occured while updating last name' }
)



// these resources are designed to fetch and edit the current user data
// ....................................................................
export const fetchUserData = fetchResource(
	USERPROFILE_RESOURCE,
)

export const addCurrentUserEmail = addResource(
	USERPROFILE_RESOURCE, 'email',
	{ success: 'Your email has been changed successfully.', error: 'An error occured while updating Your email' }
)

export const addCurrentUserPassword = addResource(
	USERPROFILE_RESOURCE, 'password',
	{ success: 'Your Password has been changed successfully.', error: 'An error occured while updating Your password' }
)

export const addCurrentUserUserName = addResource(
	USERPROFILE_RESOURCE, 'username',
	{ success: 'Your username has been changed successfully.', error: 'An error occured while updating Your username' }
)

export const addCurrentUserFirstName = addResource(
	USERPROFILE_RESOURCE, 'first_name',
	{ success: 'Your first name has been changed successfully.', error: 'An error occured while updating Your first name' }
)

export const addCurrentUserLastName = addResource(
	USERPROFILE_RESOURCE, 'last_name',
	{ success: 'Your last name has been changed successfully.', error: 'An error occured while updating Your last name' }
)

export const addTwo_factor_authentication = addResource(
	USERPROFILE_RESOURCE, 'two_factor_authentication',
	{ success: 'Two Factor Auth Updated successfully', error: 'An error occured while updating Two Factor Auth' }
)

export const addCurrentUserPages = addResource(
	SUBUSER_RESOURCE, 'allowed_pages',
	{ success: 'Page restriction has been updated.', error: 'An error occured while updating page access' }
)


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/user.js